import React from "react";
import "./style.scss";
import SellerFooterInfo from "./SellerFooterInfo";
import { useTranslation } from "react-i18next";
import EALink from "../../app/components/shared/Link/EALink";
import useShowNavBar from "../NavBar/hooks/useShowNavBar";
import { PWAVisibility } from "../../app/components/PWAButton/PwaOnly";
import DownloadPWA from "../../app/components/PWAButton/Download_PWA";

const Footer: React.FC = () => {
  const { t } = useTranslation();
  const showNavBar = useShowNavBar();

  if (!showNavBar) {
    return <></>;
  }

  return (
    <div className={"footer flex-between flex-wrap"}>
      <PWAVisibility invert fallback={null}>
        <DownloadPWA />
      </PWAVisibility>

      <span>
        <SellerFooterInfo />
      </span>
      <div className="flex-center-center">
        <span>
          {t("dostawca_systemu_do_sprzedazy_biletow_karnetow_i_uslug_online_jest_eaktywni")}
          <EALink to="https://www.eaktywni.pl" title="www.eAktywni.pl" />
        </span>
      </div>
    </div>
  );
};

export default Footer;
